import { render, staticRenderFns } from "./FirstQuestion.vue?vue&type=template&id=3a412412&scoped=true"
import script from "./FirstQuestion.vue?vue&type=script&lang=js"
export * from "./FirstQuestion.vue?vue&type=script&lang=js"
import style0 from "./FirstQuestion.vue?vue&type=style&index=0&id=3a412412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a412412",
  null
  
)

export default component.exports